module.exports = __webpack_public_path__ + "img/close.0bde5e76.svg";